"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToOptions = exports.ICON_SOURCE = exports.ICON_COLOR = exports.ICON_KIND = exports.ICON_SEGMENT = exports.ICON_ID = void 0;
/* eslint-disable prettier/prettier */
// React
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
// genero version
// Enums
const enums_1 = require("./enums");
const { ICON_ID: ICON_ID_AUX, ICON_SOURCE: ICON_SOURCE_AUX } = (0, enums_1.getIconsInfo)();
exports.ICON_ID = ICON_ID_AUX;
exports.ICON_SEGMENT = enums_1.ICON_SEGMENT;
exports.ICON_KIND = enums_1.ICON_KIND;
exports.ICON_COLOR = enums_1.ICON_COLOR;
exports.ICON_SOURCE = ICON_SOURCE_AUX;
const convertToOptions = (optionsObject) => {
    return Object.values(optionsObject);
};
exports.convertToOptions = convertToOptions;
const getProperCollection = (id, kind) => {
    return (exports.ICON_SOURCE[id] && exports.ICON_SOURCE[id][kind]) || null;
};
const Icon = (props) => {
    const { id, kind, className, color, collectionSource, segment, size, layoutSize, sizeCircular, backgroundColor, } = props;
    if (!id) {
        return null;
    }
    if (!exports.ICON_ID[id]) {
        return null;
    }
    const myId = exports.ICON_ID[id].toLowerCase() || id.toLowerCase();
    const myKind = kind.toLowerCase();
    const source = collectionSource || getProperCollection(myId, myKind);
    if (!source) {
        return null;
    }
    const style = {
        fontSize: `${size / 16}rem`,
        height: `${layoutSize.h !== 'auto' ? `${layoutSize.h / 16}rem` : 'auto'}`,
        width: `${layoutSize.w !== 'auto' ? `${layoutSize.w / 16}rem` : 'auto'}`,
        minHeight: `${size / 16}rem`,
        minWidth: `${size / 16}rem`,
    };
    const cssCircular = `${sizeCircular > 0 ? ' icon-circular' : ''}`;
    if (cssCircular) {
        style.padding = `${sizeCircular / 16}rem`;
    }
    let mySegment = segment;
    switch (segment) {
        case 'empresas':
        case 'emp':
            mySegment = 'emp';
            break;
        case 'particulares':
        default:
            mySegment = 'gp';
            break;
    }
    const cssColor = ` icon-color-${mySegment}--${color}`;
    const cssBackground = ` icon-bgColor-${mySegment}--${backgroundColor}`;
    const cssCurrentIcon = ` icon${source}-${myId}-${myKind}`;
    const ownClassName = `${className ? ` ${className}` : ''}`;
    const myClassName = `icon${cssCurrentIcon}${cssColor}${cssBackground}${cssCircular}${ownClassName}`;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { className: myClassName, style: style })));
};
Icon.propTypes = {
    id: prop_types_1.default.string.isRequired,
    kind: prop_types_1.default.oneOf(Object.values(exports.ICON_KIND)),
    className: prop_types_1.default.string,
    color: prop_types_1.default.oneOf(Object.values(exports.ICON_COLOR)),
    size: prop_types_1.default.number,
    collectionSource: prop_types_1.default.number,
    layoutSize: prop_types_1.default.shape({
        w: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
        h: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    }),
    sizeCircular: prop_types_1.default.number,
    backgroundColor: prop_types_1.default.oneOf(Object.values(exports.ICON_COLOR)),
    segment: prop_types_1.default.oneOf(Object.values(exports.ICON_SEGMENT)),
};
Icon.defaultProps = {
    kind: exports.ICON_KIND.MEDIUM,
    className: '',
    color: exports.ICON_COLOR.BLACK,
    size: 16,
    collectionSource: 0,
    layoutSize: {
        h: 'auto',
        w: 'auto',
    },
    sizeCircular: 0,
    backgroundColor: exports.ICON_COLOR.TRANSPARENT,
    segment: exports.ICON_SEGMENT.GP,
};
exports.default = Icon;
//# sourceMappingURL=index.js.map